import GLightbox from 'glightbox';

export default {
  init() {
    GLightbox();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js